import { FSCard } from '@/ui/components/FSCard';
import { translate } from '@/ui/i18n';
import { ProjectScoresDetailsTitle } from '@/ui/pages/app/components/project-page/ProjectScoresDetails/ProjectScoresDetailsTitle';
import { ColorsRaw } from '@/ui/theme/colors-raw';

import { Co2OnTourDetailsSequences } from './Co2OnTourDetailsSequences';

export function Co2OnTourDetails({
  onClickOpenOnTourSequence,
}: {
  onClickOpenOnTourSequence: (sequenceId: number) => void;
}) {
  return (
    <>
      <ProjectScoresDetailsTitle
        title={translate('ProjectsTour.project-tour-ontour')}
      />
      <FSCard
        sx={{
          backgroundColor: ColorsRaw.anthracite.Anthracite_2,
          borderColor: ColorsRaw.anthracite.Anthracite_2,
          padding: 2,
        }}
      >
        <Co2OnTourDetailsSequences
          onClickOpenOnTourSequence={onClickOpenOnTourSequence}
        />
      </FSCard>
    </>
  );
}
